import {
  REQUEST_EMAIL_CHANGE_REQUEST,
  REQUEST_EMAIL_CHANGE_SUCCESS,
  REQUEST_EMAIL_CHANGE_FAILURE,
  VERIFY_EMAIL_CHANGE_REQUEST,
  VERIFY_EMAIL_CHANGE_SUCCESS,
  VERIFY_EMAIL_CHANGE_FAILURE,
  RESEND_EMAIL_CHANGE_REQUEST,
  RESEND_EMAIL_CHANGE_SUCCESS,
  RESEND_EMAIL_CHANGE_FAILURE,
  CHECK_EMAIL_MIGRATION_STATUS_REQUEST,
  CHECK_EMAIL_MIGRATION_STATUS_SUCCESS,
  CHECK_EMAIL_MIGRATION_STATUS_FAILURE,
  RESET_EMAIL_MIGRATION_STATE,
} from '../../../Constants/actionTypes';

const initialState = {
  requestLoading: false,
  verifyLoading: false,
  resendLoading: false,
  statusLoading: false,
  requestSuccess: false,
  verifySuccess: false,
  resendSuccess: false,
  migrationCompleted: null,
  statusMessage: '',
  statusError: null,
  response: null,
  error: null,
};

const emailMigrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_EMAIL_CHANGE_REQUEST:
      return { ...state, requestLoading: true, requestSuccess: false, error: null };
    case REQUEST_EMAIL_CHANGE_SUCCESS:
      return { ...state, requestLoading: false, requestSuccess: true, response: action.payload, error: null };
    case REQUEST_EMAIL_CHANGE_FAILURE:
      return { ...state, requestLoading: false, requestSuccess: false, error: action.payload };

    case VERIFY_EMAIL_CHANGE_REQUEST:
      return { ...state, verifyLoading: true, verifySuccess: false, error: null };
    case VERIFY_EMAIL_CHANGE_SUCCESS:
      return { ...state, verifyLoading: false, verifySuccess: true, response: action.payload, error: null };
    case VERIFY_EMAIL_CHANGE_FAILURE:
      return { ...state, verifyLoading: false, verifySuccess: false, error: action.payload };

    case RESEND_EMAIL_CHANGE_REQUEST:
      return { ...state, resendLoading: true, resendSuccess: false, error: null };
    case RESEND_EMAIL_CHANGE_SUCCESS:
      return { ...state, resendLoading: false, resendSuccess: true, response: action.payload, error: null };
    case RESEND_EMAIL_CHANGE_FAILURE:
      return { ...state, resendLoading: false, resendSuccess: false, error: action.payload };

    case CHECK_EMAIL_MIGRATION_STATUS_REQUEST:
      return { ...state, statusLoading: true, statusError: null };
    case CHECK_EMAIL_MIGRATION_STATUS_SUCCESS:
      return {
        ...state,
        statusLoading: false,
        migrationCompleted: Boolean(action.payload?.migrationCompleted),
        statusMessage: action.payload?.message || '',
        statusError: null,
      };
    case CHECK_EMAIL_MIGRATION_STATUS_FAILURE:
      return {
        ...state,
        statusLoading: false,
        migrationCompleted: false,
        statusMessage: '',
        statusError: action.payload,
      };

    case RESET_EMAIL_MIGRATION_STATE:
      return initialState;

    default:
      return state;
  }
};

export default emailMigrationReducer;

